import { render, staticRenderFns } from "./block-ui.vue?vue&type=template&id=f65f321a&scoped=true"
import script from "./block-ui.vue?vue&type=script&lang=js"
export * from "./block-ui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f321a",
  null
  
)

export default component.exports